import { concatWithPrefix } from '@sravni/cosago-react-library/lib/utils';
import {
  EMPLOYMENT_VALUES as EMPLOYMENT_TYPE_VALUES,
  UNEMPLOYMENT_REASONS,
} from '@sravni/creditselection-customer-utils/lib/utils/customers';

import { CURRENCY_CHAR } from 'constants/currency';
import { HIDE_DATA_SYMBOL, UNBREAKABLE_SEPARATOR } from 'constants/string';

import { formatNumber } from 'shared/lib/formatters';

import type { TWorkplaceFormFields } from 'entities/creditForm';

import { AccordionHeaderParamsTexts } from './AccordionHeaderParams.texts';

export const formatWorkplaceDescription = (data: TWorkplaceFormFields, isHideData = false) => {
  const { employmentType, workOrganizationName, monthlySalary, unemploymentReason, anotherUnemploymentReason } = data;
  const hasData = Boolean(employmentType?.value || workOrganizationName);

  if (isHideData && hasData) {
    return Array(3).fill(HIDE_DATA_SYMBOL.repeat(4)).join(UNBREAKABLE_SEPARATOR);
  }

  switch (employmentType?.value) {
    case EMPLOYMENT_TYPE_VALUES.NOT_WORKING_VALUE: {
      if (unemploymentReason?.value === UNEMPLOYMENT_REASONS.OTHER) {
        return anotherUnemploymentReason || AccordionHeaderParamsTexts.HeaderDefaultDescription;
      }
      return unemploymentReason?.label;
    }
    case EMPLOYMENT_TYPE_VALUES.RETIRED: {
      return concatWithPrefix(
        'Ежемесячный доход',
        `${formatNumber(Number(monthlySalary))} ${CURRENCY_CHAR}`,
        UNBREAKABLE_SEPARATOR,
      );
    }
    default: {
      return workOrganizationName || AccordionHeaderParamsTexts.HeaderDefaultDescription;
    }
  }
};
